export function formatUserName(user) {
    if (!user) return '';
    const name = `${user.first_name || ''} ${user.last_name || ''}`.trim();
    if (name) return name;
    if (user.email) return user.email;
    if (user.user_id != null) return `User #${user.user_id}`;
    return 'Unknown';
}

export function mergeUsersById(...groups) {
    const byId = new Map();
    for (const group of groups) {
        for (const user of group || []) {
            if (user?.user_id != null) {
                byId.set(Number(user.user_id), user);
            }
        }
    }
    return [...byId.values()];
}

export function buildUserOptions(users, extraUsers = []) {
    return mergeUsersById(users, extraUsers)
        .sort((a, b) => formatUserName(a).localeCompare(formatUserName(b)))
        .map((user) => ({
            label: formatUserName(user),
            value: Number(user.user_id),
        }));
}

export function normalizeUserIds(ids) {
    return (ids || []).map((id) => Number(id)).filter((id) => Number.isFinite(id));
}

export function withDisplayName(users) {
    return (users || []).map((user) => ({
        ...user,
        name: formatUserName(user),
    }));
}
